import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

// Components
import PageSearch from "./PageSearch";
import Page from "./Page";

// State
import { setpageTitle } from "../../../store/actions/siteInfo";
import { addRoute } from "../../../store/actions/route";

class AdminPageContents extends Component {
	constructor(props) {
		super(props);
		this.props.addRoute(this.props.match);
		this.props.setpageTitle("Update Pages");
	}

	render() {
		return (
			<React.Fragment>
				<h1>Update Pages</h1>

				<Switch>
					<Route path={"/admin/pages"} exact component={PageSearch} />
					<Route path={"/admin/pages/:id"} component={Page} />
				</Switch>
			</React.Fragment>
		);
	}
}

export default connect(
	null,
	{ addRoute, setpageTitle }
)(AdminPageContents);



// WEBPACK FOOTER //
// ./src/components/admin/pages/AdminPageContents.js